import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import { relAttrGrpAttrAssocObj } from "data/globalData";
import { relookBackendInstance } from "utils/AxiosInstances/RelookBackendInstance";
import { GlobalState } from "./GlobalContext";

const ReplenishmentContext = createContext();

const ReplenishmentProvider = ({ children }) => {
	const { snackbar, setSnackBar, setSnackBarOpen } = GlobalState();

	const [allStores, setAllStores] = useState();
	const [itemMastDropdownsList, setItemMastDropdownsList] = useState([]);
	const [allWarehouses, setAllWarehouses] = useState();

	const fetch = async () => {
		try {
			await axios.get(`/api/item_master/get_distinct_im_main_fields`).then((res) => {
				setItemMastDropdownsList(res.data?.result);
			});
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackbar,
				message: "Unable to fetch  Attributes",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const fetchWarehouses = async () => {
		try {
			await axios.get(`/api/custom_queries/get_warehouses_list`).then((res) => {
				setAllWarehouses(res.data?.result);
			});
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackbar,
				message: "Unable to fetch Warehouses",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const fetchAllStores = async () => {
		try {
			const {
				data: { result },
			} = await axios.get(`/api/replenishment/get_all_stores`);
			setAllStores(result);
		} catch (error) {
			console.log("Unable to fetch all stores" + ":" + error);
		}
	};

	useEffect(() => {
		fetchAllStores();
		fetch();
		fetchWarehouses();
	}, []);

	return (
		<ReplenishmentContext.Provider
			value={{
				allStores,
				setAllStores,
				itemMastDropdownsList,
				allWarehouses,
			}}>
			<Outlet />
		</ReplenishmentContext.Provider>
	);
};

export const ReplenishmentState = () => {
	return useContext(ReplenishmentContext);
};

export default ReplenishmentProvider;
